import { render, staticRenderFns } from "./DetailedTransactions.vue?vue&type=template&id=0a2e3f1c&"
import script from "./DetailedTransactions.vue?vue&type=script&lang=js&"
export * from "./DetailedTransactions.vue?vue&type=script&lang=js&"
import style0 from "./DetailedTransactions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports